import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import CheckCSName from "../CheckCSName";
import EmptyLine from "../EmptyLine";
import {useUser} from "../../../context/UserContext";
import ResultView from "../../../components/ResultView";

export function B25({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.FW00a.error_id: {
            return (
                <>
                    <ResultText>
                        The following Encroachment River Stations listed in the plan file are missing in the geometry file.
                        <EmptyLine />
                        <CheckCSName csNameList={row?.data?.map(x => x.cross_section)} />
                    </ResultText>
                </>
            )
        }
        case MessageCodes.Internal.FW00b.error_id: {
            return (
                <>
                    <ResultText>
                        The following Cross Section River Stations listed in the geometry file are missing in the Encroachment River Stations listed in the plan file.
                        <EmptyLine />
                        <CheckCSName csNameList={row?.data?.map(x => x.cross_section)} />
                    </ResultText>
                </>
            )
        }
    }
}